import type { ReactNode } from 'react'
import {
  type ContainerProps,
  css,
  styled,
  Table,
  TableCell,
  TableRow,
} from '@mui/material'
import type { Theme } from '@mui/material/styles'
import { type Field, PuiTextArea } from '@pbt/pbt-ui-components'

const Container = styled(Table, {
  shouldForwardProp: (props) => props !== 'backgroundColor',
})<ContainerProps & { backgroundColor?: keyof Theme['colors'] }>`
  width: 100%;
  ${({ theme, backgroundColor }) =>
    backgroundColor
      ? css`
          background-color: ${theme.colors[backgroundColor]};
        `
      : ''}
`

const StyledFieldTableCell = styled(TableCell)`
  padding: ${({ theme }) => `0 ${theme.spacing(0.5)} ${theme.spacing(0.5)}`};
`

const StyledTableCell = styled(TableCell)`
  padding: ${({ theme }) =>
    `${theme.spacing(0.5)} ${theme.spacing(0.5)} ${theme.spacing(0.5)}`};
`

const FieldsContainer = styled(TableRow)``

export interface PreviousMedicalHistoryItemProps {
  backgroundColor?: keyof Theme['colors']
  fields?: { field: ReactNode; name: string; width: string }[]
  notes?: Field
}

export const PreviousMedicalHistoryItem = ({
  fields,
  notes,
  backgroundColor,
}: PreviousMedicalHistoryItemProps) => (
  <Container backgroundColor={backgroundColor}>
    {fields?.map(({ width, name }) => (
      <col key={name} width={width} />
    ))}
    <FieldsContainer>
      {fields?.map(({ name, field }) => (
        <StyledFieldTableCell key={name}>{field}</StyledFieldTableCell>
      ))}
    </FieldsContainer>
    <FieldsContainer>
      <StyledTableCell colSpan={fields?.length}>
        <PuiTextArea field={notes} margin="none" />
      </StyledTableCell>
    </FieldsContainer>
  </Container>
)
